import type { ReactNode } from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { useCurrentUser } from '../../hooks/useCurrentUser.ts'

type ProtectedRouteProps = {
  children?: ReactNode
  requireAdmin?: boolean
}

export function ProtectedRoute({ children, requireAdmin = false }: ProtectedRouteProps) {
  const { authStatus, domainUserStatus, isEnabled, isAdmin } = useCurrentUser()

  if (authStatus === 'loading' || domainUserStatus === 'loading') {
    return <div>Carregando...</div>
  }

  if (authStatus === 'unauthenticated') {
    return <Navigate to="/" replace />
  }

  if (requireAdmin ? !isAdmin : !isEnabled) {
    return <Navigate to="/" replace />
  }

  return children ?? <Outlet />
}
